<template>
  <div>
    <div v-if="useMenu">
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <div
            v-on="on"
          >
            <img
              :src="'/img/' + options.filter(option => option.lang === lang)[0].flag + '.svg'"
              style="position: relative; top: 3px; left: 0; width: 25px; margin-right: 10px;"
            >
            <!-- v-icon small
              style="color: #333333 !important; position: relative; top: -1px; padding-left: 8px; padding-right: 6px;"
            >
              fa-angle-down
            </v-icon -->
          </div>
        </template>
        <v-list>
          <template v-for="(option, i) in options">
            <v-list-tile
              v-if="option.lang !== lang"
              :key="i"
              @click=""
            >
              <v-list-tile-title>
                <a @click="clickHandler(option.lang)">
                  <img :src="'/img/' + option.flag + '.svg'"
                  style="border: 1px solid grey; width: 31px;"
                >
                </a>
              </v-list-tile-title>
            </v-list-tile>
          </template>
        </v-list>
      </v-menu>
    </div>
    <div v-else :class="className">
      <a @click="clickHandler('et')"><img style="width: 31px;" src="/img/est.svg" alt="Eesti"></a>
      <a @click="clickHandler('en')"><img style="width: 31px;" src="/img/eng.svg" alt="English"></a>
      <a @click="clickHandler('fi')"><img style="width: 31px;" src="/img/fin.svg" alt="Finnish"></a>
      <a @click="clickHandler('ru')"><img style="width: 31px;" src="/img/rus.svg" alt="Russian"></a>
      <a @click="clickHandler('es')"><img style="width: 31px;" src="/img/esp.svg" alt="Spanish"></a>
    </div>
  </div>
</template>

<script>
import sharedMethods from './../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'Flags',

  props: {
    className: {
      type: String,
      default: null
    },
    useMenu: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      options: [{
        lang: 'et', flag: 'est'
      }, {
        lang: 'en', flag: 'eng'
      },{
        lang: 'fi', flag: 'fin'
      },{
        lang: 'ru', flag: 'rus'
      },{
        lang: 'es', flag: 'esp'
      }]
    }
  },

  computed: {
    ...mapFields(Object.keys(state))
  },

  methods: {
    ...sharedMethods,

    clickHandler (lang) {
      this.changeLang(lang)
      this.$nextTick(() => {
        if (this.className === 'flags-menu') {
          this.showRightMenu = true
        }
      })
    }
  }
}
</script>
